import * as Lambda from '../../services/LambdaApi';
import { Birthday } from '../types/Birthday';

const listAllBirthdays = async ({
    facilityId,
    startDate,
    endDate,
}: {
    facilityId: string;
    startDate: string;
    endDate: string;
}): Promise<{ Result: Birthday[]; TotRecords: number }> => {
    const apiPath = `/s2l/${facilityId}/listAllBirthdays`;
    const params = {
        Filter: {
            Facility: facilityId,
            startDate,
            endDate,
        },
    };
    const response = await Lambda.Post(apiPath, params, 'lambda');
    if (!response?.Result?.Content) {
        throw new Error('Error fetching birthdays');
    }
    return response.Result.Content as { Result: Birthday[]; TotRecords: number };
};

const getBirthdaySignedImageUrls = async ({
    facilityId,
    birthdayId,
    fileName,
}: {
    facilityId: string;
    birthdayId: string;
    fileName: string;
}): Promise<string> => {
    const apiPath = `/s2l/${facilityId}/getBirthdaySignedImageUrls`;
    const params = { birthdayId, fileName };
    const response = await Lambda.Post(apiPath, params, 'lambda');
    if (!response?.Result?.Content) {
        throw new Error('Error fetching birthday image URL');
    }
    return response.Result.Content as string;
};

export { listAllBirthdays, getBirthdaySignedImageUrls };
